import { SVGProps, Ref, forwardRef } from 'react';

export const StarFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m4.809 14.595.628.538-.204.856c-.946 3.978-1.419 5.967-.34 6.75s2.824-.28 6.315-2.41l.766-.467.767.468c3.49 2.129 5.236 3.193 6.315 2.41 1.078-.784.605-2.773-.34-6.751l-.196-.82.67-.574c3.104-2.662 4.656-3.993 4.244-5.261S20.984 7.9 16.91 7.572l-.867-.07-.35-.84C14.12 2.887 13.333 1 12 1S9.88 2.887 8.308 6.662l-.35.84-.867.07C3.015 7.9.977 8.064.565 9.333c-.412 1.268 1.14 2.599 4.244 5.26"
                fill="currentColor"
            />
        </g>
    </svg>
));
StarFilledSize24Glyph.displayName = 'StarFilledSize24Glyph';
